var styles = {
  "Item": "Online-Store-UI-Item_ko3ui",
  "disabled": "Online-Store-UI-Item--disabled_wefkc",
  "active": "Online-Store-UI-Item--active_1x005",
  "current": "Online-Store-UI-Item--current_1dqjf",
  "interactive": "Online-Store-UI-Item--interactive_112r6",
  "Action": "Online-Store-UI-Item__Action_1s7qt",
  "disabledBackground": "Online-Store-UI-Item--disabledBackground_9oeof",
  "Content": "Online-Store-UI-Item__Content_1dqhs",
  "IconPrefix": "Online-Store-UI-Item__IconPrefix_xregw",
  "Prefix": "Online-Store-UI-Item__Prefix_4vkyu",
  "Suffix": "Online-Store-UI-Item__Suffix_4vky0"
};

export { styles as default };
